export default function getUsedLocale(): string {
    const browserLocale = window.navigator.language.split('-')[0]
    const localeFromStorage = window.localStorage.getItem('applyLocale')

    if (localeFromStorage) {
        return localeFromStorage
    }

    return 'fr'
}
